import { useNavigate, useParams, useLocation, Navigate } from 'react-router-dom';
import { BookEditForm } from '../components/wizard';
import type { EditTabId } from '../components/wizard/BookEditForm';

export default function EditBookPage() {
  const navigate = useNavigate();
  const { bookId } = useParams<{ bookId: string }>();
  const location = useLocation();

  const getInitialTab = (): EditTabId => {
    if (location.pathname.endsWith('/audience')) return 'audience';
    if (location.pathname.endsWith('/description')) return 'description';
    if (location.pathname.endsWith('/cover')) return 'cover';
    return 'about';
  };

  // Legacy /edit/storyteller — voice moved to workspace drawer.
  if (location.pathname.endsWith('/storyteller') && bookId) {
    return <Navigate to={`/books/${bookId}/refine?voice=open`} replace />;
  }

  const handleComplete = (completedBookId: string) => {
    navigate(`/books/${completedBookId}`);
  };

  const handleCancel = () => {
    if (bookId) {
      navigate(`/books/${bookId}`);
    } else {
      navigate('/books');
    }
  };

  const handleTabChange = (tab: EditTabId) => {
    if (!bookId) return;

    if (tab === 'about') {
      navigate(`/books/${bookId}/edit`, { replace: true });
    } else if (tab === 'audience') {
      navigate(`/books/${bookId}/edit/audience`, { replace: true });
    } else if (tab === 'description') {
      navigate(`/books/${bookId}/edit/description`, { replace: true });
    } else if (tab === 'cover') {
      navigate(`/books/${bookId}/edit/cover`, { replace: true });
    }
  };

  if (!bookId) {
    navigate('/books');
    return null;
  }

  return (
    <BookEditForm
      bookId={bookId}
      initialTab={getInitialTab()}
      onComplete={handleComplete}
      onCancel={handleCancel}
      onTabChange={handleTabChange}
    />
  );
}
